import './stats.css';
const AboutStats = () => {
    return (
        <div className="about-section__stats">
            <div className="about-section__item one">
                <p className="about-section__itemH">25,000+</p>
                <p className="about-section__itemS">Trained Professionals</p>
            </div>
            <div className="about-section__item two">
                <p className="about-section__itemH">5 Million+</p>
                <p className="about-section__itemS">Happy Customers</p>
            </div>
            <div className="about-section__item three">
                <p className="about-section__itemH">30</p>
                <p className="about-section__itemS">Cities</p>
            </div>
            <div className="about-section__item four">
                <p className="about-section__itemH">2</p>
                <p className="about-section__itemS">Countries</p>
            </div>
        </div>
    )
}

export default AboutStats